// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatList__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatList.scss
 ** module id = 877
 ** module chunks = 1
 **/